<template>
  <div>
    <div class="header-wrapper-exception redarc-banner">
      <h2>Black Diamond</h2>
      <hr class="line" />
    </div>
    <b-container>
      <div class="grid">
        <div class="text">
          <p>
            Black Diamond brand was established in 1993 in the United Kingdom.
            The main goal of its founders is to improve the quality of
            production and the availability of reliable brake parts for sports
            cars. Proof of this motto's authenticity is the fact that when Black
            Diamond was invited in 1996 to participate in the first test of the
            prestigious British magazine Max Power, it was immediately declared
            the winner.
          </p>
          <p>
            Black Diamond product achieved such a significant advantage over
            other leading brands in the market that the editors of Max Power
            decided not to award a second place at all! And that's not all, in
            the following years more awards came, both for brake discs, brake
            pads, and complete sets. Black Diamond is mainly famous for its
            slotted and drilled brake discs and the sports Predator pads, but
            the offer includes a total of four types of discs, two types of
            pads, steel lines, brake fluids, and clutches.
          </p>
        </div>
        <div class="image">
          <picture>
            <source
              type="image/webp"
              srcset="./../../assets/brands-logos/bd.webp"
            />
            <img src="./../../assets/brands-logos/bd.png" alt="Black Diamond" />
          </picture>
        </div>
      </div>
    </b-container>
    <page-header
      :text="$t('importantLinks')"
      font="black"
      back="white"
    ></page-header>
    <b-container>
      <div class="link-items">
        <router-link to="/catalogue/black-diamond">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon
            >{{ $t("catalogue") }} ON-LINE
          </div>
        </router-link>
        <router-link to="/pricelist">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("pricelist") }}
          </div>
        </router-link>
        <a href="http://www.blackdiamondperformance.com/" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("website") }}
          </div>
        </a>
      </div>
      <brands class="brands" />
    </b-container>
  </div>
</template>

<script>
import Brands from "@/components/brands/Brands.vue";
import PageHeader from "@/components/common/PageHeader.vue";
import { mapGetters } from "vuex";

export default {
  name: "RedarcEn",
  components: { Brands, PageHeader },
  computed: {
    ...mapGetters(["isUserLogged"]),
  },
};
</script>
